module.exports = __webpack_public_path__ + "img/icon-plus.162760c3.svg";